import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const r = await axios.post(`${API}/newsletter`, { email });
      if (r.data?.already_subscribed) toast.success("Already on the list");
      else toast.success("Welcome to the order");
      setEmail("");
    } catch (err) {
      toast.error("Enter a valid address");
    } finally {
      setLoading(false);
    }
  }

  return (
    <section id="newsletter" data-testid="newsletter-section" className="relative py-28 md:py-40 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="hero-glow" style={{ top: "10%", left: "10%", opacity: 0.7 }} />
      </div>
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 relative">
        <div className="grid grid-cols-12 gap-6 items-end">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 lg:col-span-7"
          >
            <div className="eyebrow mb-4">Correspondence</div>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight text-bone">
              Join the <em className="italic" style={{ color: "var(--amber)" }}>Order</em>.
            </h2>
            <p className="font-body text-lg text-bone-dim mt-6 max-w-xl">
              New drams found, old ones revisited, and the odd recommendation from
              our shelves. No advertisers. No noise.
            </p>
          </motion.div>

          <motion.form
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            onSubmit={submit}
            data-testid="newsletter-form"
            className="col-span-12 lg:col-span-5 flex flex-col gap-4"
          >
            <label className="eyebrow" htmlFor="email">Your address</label>
            <div className="flex items-center gap-4 border-b pb-3" style={{ borderColor: "var(--brass)" }}>
              <input
                id="email"
                data-testid="newsletter-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@yourfineself.com"
                className="flex-1 bg-transparent outline-none font-body text-lg placeholder:text-bone-dim text-bone"
              />
              <button
                type="submit"
                data-testid="newsletter-submit"
                disabled={loading}
                className="btn-outline disabled:opacity-60"
              >
                {loading ? "Sending" : "Sign the Ledger"}
              </button>
            </div>
            <p className="font-body text-sm text-bone-dim italic">
              We keep our correspondence private. Unsubscribe from any letter.
            </p>
          </motion.form>
        </div>
      </div>
    </section>
  );
}
